var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14643",
    "data-name": "Group 14643",
    transform: "translate(-0.483)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96",
    "data-name": "Ellipse 96",
    cx: 27,
    cy: 27,
    r: 27,
    transform: "translate(0.483)",
    fill: "#e53737"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-trash-alt",
    "data-name": "Icon awesome-trash-alt",
    d: "M1.773,25.7a2.659,2.659,0,0,0,2.659,2.659H20.385A2.659,2.659,0,0,0,23.044,25.7V7.09H1.773ZM16.84,11.522a.886.886,0,0,1,1.773,0V23.93a.886.886,0,1,1-1.773,0Zm-5.318,0a.886.886,0,0,1,1.773,0V23.93a.886.886,0,1,1-1.773,0Zm-5.318,0a.886.886,0,0,1,1.773,0V23.93a.886.886,0,1,1-1.773,0ZM23.93,1.773H17.283L16.762.737A1.329,1.329,0,0,0,15.571,0H9.24A1.314,1.314,0,0,0,8.054.737L7.534,1.773H.886A.886.886,0,0,0,0,2.659V4.432a.886.886,0,0,0,.886.886H23.93a.886.886,0,0,0,.886-.886V2.659A.886.886,0,0,0,23.93,1.773Z",
    transform: "translate(14.693 12.896)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete);
export default __webpack_public_path__ + "static/media/icon-delete.eb208f30905629fdaf6e7fee17e2b64e.svg";
export { ForwardRef as ReactComponent };